import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IntNativeElementDirective} from "./int-native-element.directive";

@NgModule({
  imports: [CommonModule],
  declarations: [IntNativeElementDirective],
  exports: [IntNativeElementDirective]
})
export class IntNativeElementModule {}
